import { render, staticRenderFns } from "./FormRichEditor.vue?vue&type=template&id=5b07c606&"
import script from "./FormRichEditor.vue?vue&type=script&lang=js&"
export * from "./FormRichEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports